import {DataTableCellProps, TemporalFormat, tryParseInstant} from "@variocube/app-ui";
import React from "react";
import {Booking} from "../../api";

export function BookingFromCell({row}: DataTableCellProps<Booking>) {
	const from = tryParseInstant(row.from);
	return from ? <TemporalFormat value={from} /> : null;
}
